/* Fleurity — página de produto
   Galeria, seletor de kit, variantes, preço, adicionar ao carrinho e barra fixa. */
(function () {
  'use strict';

  var SIZE_WORDS = /tamanho|size/i;
  var COLOR_WORDS = /cor|color|colour/i;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    var fmt = format || 'R$ {{amount_with_comma_separator}}';
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount_with_comma_separator';
    function withDelims(n, precision, thousands, decimal) {
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? intPart + decimal + parts[1] : intPart;
    }
    var value;
    switch (key) {
      case 'amount': value = withDelims(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/^tipo\s+mini/, 'mini').replace(/\s+/g, ' ').trim();
  }
  // chave curta de tamanho: "Tipo 2 (-35 anos)" -> "tipo 2", "Tipo Mini (-18 anos)" -> "mini"
  function sizeKey(s) { return norm(s).replace(/\(.*\)/, '').trim(); }

  function splitLabel(value) {
    var m = String(value).match(/^(.*?)\s*\((.*)\)\s*$/);
    if (!m) return { main: value, sub: '' };
    var sub = m[2].trim()
      .replace(/^-\s*(\d+)\s*anos?$/i, 'até $1 anos')
      .replace(/^\+\s*(\d+)\s*anos?$/i, 'acima de $1 anos');
    return { main: m[1].replace(/^Tipo\s+Mini$/i, 'Mini'), sub: sub };
  }

  function parseSwatches(text) {
    var map = {};
    String(text || '').split(/\n|,/).forEach(function (line) {
      var i = line.indexOf(':');
      if (i < 0) return;
      map[norm(line.slice(0, i))] = line.slice(i + 1).trim();
    });
    return map;
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'class') node.className = attrs[k];
      else if (k === 'text') node.textContent = attrs[k];
      else if (k === 'html') node.innerHTML = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function FlProduct(root) {
    this.root = root;
    var dataEl = root.querySelector('[data-fl-data]');
    if (!dataEl) return;
    try { this.data = JSON.parse(dataEl.textContent); } catch (e) { console.error('[Fleurity] dados do produto inválidos', e); return; }
    this.swatches = parseSwatches(this.data.swatches);
    this.offerIndex = 0;
    this.selected = [];
    this.variant = null;

    this.optionsWrap = root.querySelector('[data-fl-options]');
    this.submit = root.querySelector('[data-fl-submit]');
    this.submitText = root.querySelector('[data-fl-submit-text]');
    this.variantInput = root.querySelector('[data-fl-variant-input]');
    this.form = root.querySelector('[data-fl-form]');
    this.error = root.querySelector('[data-fl-error]');
    this.buttonLabel = (this.submit && this.submit.dataset.label) || 'Adicionar ao carrinho';
    this.subWrap = root.querySelector('[data-fl-sub]');
    this.planInput = root.querySelector('[data-fl-plan-input]');
    this.planId = null;

    // oferta inicial = a que usa o produto da página
    var self = this;
    var firstMain = this.data.offers.findIndex(function (o) { return o.product && o.product.id === self.data.mainProductId; });
    this.offerIndex = firstMain >= 0 ? firstMain : 0;

    this.initGallery();
    this.initOffers();
    this.initVariant();
    this.initForm();
    this.initSticky();
  }

  FlProduct.prototype.product = function () { return this.data.offers[this.offerIndex].product; };

  /* ---------- Galeria ---------- */
  FlProduct.prototype.initGallery = function () {
    var root = this.root;
    this.track = root.querySelector('[data-fl-track]');
    if (!this.track) return;
    var slides = this.track.children;
    var thumbs = root.querySelectorAll('[data-fl-thumbs] [data-index]');
    var counter = root.querySelector('[data-fl-current]');
    var self = this;

    this.goTo = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      self.track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    };
    var prev = root.querySelector('[data-fl-prev]');
    var next = root.querySelector('[data-fl-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(self.current - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { self.goTo(Number(t.dataset.index)); }); });
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.current - 1); }
    });

    this.current = 0;
    var ticking = false;
    this.track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(self.track.scrollLeft / Math.max(1, self.track.clientWidth));
        if (i === self.current) return;
        self.current = i;
        if (counter) counter.textContent = i + 1;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', Number(t.dataset.index) === i); });
        var active = root.querySelector('[data-fl-thumbs] .is-active');
        if (active && active.scrollIntoView) {
          var strip = active.parentElement;
          strip.scrollTo({ left: active.offsetLeft - strip.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
        }
        // pausa vídeos fora da tela
        root.querySelectorAll('.fl-gallery__slide video').forEach(function (v) { if (!v.paused) v.pause(); });
      });
    }, { passive: true });
  };

  FlProduct.prototype.showMedia = function (mediaId) {
    if (!mediaId || !this.track) return;
    var slide = this.track.querySelector('[data-media-id="' + mediaId + '"]');
    if (slide) this.goTo(Number(slide.dataset.index));
  };

  /* ---------- Ofertas ---------- */
  FlProduct.prototype.initOffers = function () {
    var self = this;
    this.offerEls = this.root.querySelectorAll('[data-fl-offer]');
    this.offerEls.forEach(function (label) {
      var input = label.querySelector('input');
      input.addEventListener('change', function () {
        if (!input.checked) return;
        self.selectOffer(Number(label.dataset.flOffer));
      });
    });
    this.markOffer();
  };

  FlProduct.prototype.markOffer = function () {
    var idx = this.offerIndex;
    this.offerEls.forEach(function (l) {
      var on = Number(l.dataset.flOffer) === idx;
      l.classList.toggle('is-selected', on);
      l.querySelector('input').checked = on;
    });
  };

  FlProduct.prototype.selectOffer = function (idx) {
    var prevSelected = this.selected.slice();
    var prevProduct = this.product();
    this.offerIndex = idx;
    this.planId = null;
    this.markOffer();
    // tenta manter tamanho e cor escolhidos
    var product = this.product();
    var wanted = {};
    prevProduct.options.forEach(function (name, i) { wanted[norm(name)] = prevSelected[i]; });
    var start = null;
    var candidates = product.variants.filter(function (v) { return v.available; });
    if (!candidates.length) candidates = product.variants;
    var best = null, bestScore = -1;
    candidates.forEach(function (v) {
      var score = 0;
      product.options.forEach(function (name, i) {
        var w = wanted[norm(name)];
        if (!w) return;
        var val = v.options[i];
        if (SIZE_WORDS.test(name) ? sizeKey(val) === sizeKey(w) : norm(val) === norm(w)) score += SIZE_WORDS.test(name) ? 10 : 1;
      });
      if (score > bestScore) { bestScore = score; best = v; }
    });
    start = best || product.variants[0];
    this.setVariant(start);
  };

  /* ---------- Variantes ---------- */
  FlProduct.prototype.initVariant = function () {
    var product = this.product();
    var v = null;
    var self = this;
    if (this.data.respectUrlVariant) {
      v = product.variants.find(function (x) { return x.id === self.data.currentVariantId; });
    }
    if (!v && this.data.defaultSize) {
      var key = norm(this.data.defaultSize);
      v = product.variants.find(function (x) { return x.available && x.options.some(function (o) { return norm(o).indexOf(key) === 0; }); });
    }
    if (!v) v = product.variants.find(function (x) { return x.available; }) || product.variants[0];
    this.setVariant(v, { silentUrl: true });
  };

  FlProduct.prototype.findVariant = function (selected) {
    return this.product().variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });
  };

  FlProduct.prototype.pick = function (optIndex, value) {
    var product = this.product();
    var next = this.selected.slice();
    next[optIndex] = value;
    var v = this.findVariant(next);
    if (!v || !v.available) {
      // escolhe a primeira variante disponível com esse valor, mantendo o que der
      var withValue = product.variants.filter(function (x) { return x.options[optIndex] === value; });
      var avail = withValue.filter(function (x) { return x.available; });
      var pool = avail.length ? avail : withValue;
      var self = this;
      pool.sort(function (a, b) {
        var sa = 0, sb = 0;
        a.options.forEach(function (o, i) { if (o === self.selected[i]) sa++; });
        b.options.forEach(function (o, i) { if (o === self.selected[i]) sb++; });
        return sb - sa;
      });
      v = pool[0] || v;
    }
    if (v) this.setVariant(v);
  };

  FlProduct.prototype.setVariant = function (variant, opts) {
    opts = opts || {};
    this.variant = variant;
    this.selected = variant.options.slice();
    this.renderOptions();
    this.renderSub();
    this.renderPrice();
    this.renderButton();
    if (this.variantInput) this.variantInput.value = variant.id;
    var isMain = this.product().id === this.data.mainProductId;
    if (isMain && variant.featured_media) this.showMedia(variant.featured_media.id);
    if (isMain && !opts.silentUrl && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
    this.root.dispatchEvent(new CustomEvent('fl:variant', { detail: { variant: variant }, bubbles: true }));
  };

  FlProduct.prototype.isValueAvailable = function (optIndex, value) {
    var sel = this.selected;
    return this.product().variants.some(function (v) {
      if (!v.available || v.options[optIndex] !== value) return false;
      // disponível combinando com as escolhas anteriores (ordem das opções)
      for (var i = 0; i < optIndex; i++) if (v.options[i] !== sel[i]) return false;
      return true;
    });
  };

  FlProduct.prototype.renderOptions = function () {
    if (!this.optionsWrap) return;
    var self = this;
    var product = this.product();
    this.optionsWrap.innerHTML = '';
    // mais de uma opção de cor (ex.: cor do coletor e cor do copo): mantém o nome inteiro para não virar dois "Cor"
    var colorCount = 0;
    product.options.forEach(function (n, i) {
      var vals = [];
      product.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
      if (vals.length > 1 && !SIZE_WORDS.test(n) && COLOR_WORDS.test(n)) colorCount++;
    });
    product.options.forEach(function (name, optIndex) {
      var values = [];
      product.variants.forEach(function (v) { if (values.indexOf(v.options[optIndex]) < 0) values.push(v.options[optIndex]); });
      if (values.length < 2) return; // opção de valor único não precisa de escolha

      var isSize = SIZE_WORDS.test(name);
      var isColor = !isSize && COLOR_WORDS.test(name);
      var current = self.selected[optIndex];
      var currentLabel = isSize ? splitLabel(current) : { main: current, sub: '' };

      var shortName = isSize ? 'Tamanho' : (isColor ? (colorCount > 1 ? name : 'Cor') : name);
      var head = el('div', { class: 'fl-opt__head' }, [
        el('span', { class: 'fl-opt__name', html: shortName + ': <span>' + currentLabel.main + '</span>' })
      ]);
      if (isSize && self.data.sizeGuideAnchor) {
        head.appendChild(el('a', { class: 'fl-link fl-opt__guide', href: self.data.sizeGuideAnchor, text: 'Guia de tamanhos' }));
      }
      var list = el('div', { class: 'fl-opt__values', role: 'group', 'aria-label': name });
      values.forEach(function (value) {
        var available = self.isValueAvailable(optIndex, value);
        var pressed = value === current;
        if (isColor && !available && !pressed) return; // cor esgotada nesse tamanho: some da lista em vez de aparecer riscada
        var btn;
        if (isColor) {
          var hex = self.swatches[norm(value)];
          btn = el('button', { type: 'button', class: 'fl-pill fl-pill--swatch', 'aria-pressed': String(pressed) }, [
            hex ? el('span', { class: 'fl-swatch', style: '--sw:' + hex }) : null,
            el('span', { text: value })
          ]);
        } else {
          var lab = isSize ? splitLabel(value) : { main: value, sub: '' };
          btn = el('button', { type: 'button', class: 'fl-pill', 'aria-pressed': String(pressed) }, [
            el('span', { text: lab.main }),
            lab.sub ? el('small', { text: lab.sub }) : null
          ]);
        }
        if (!available) { btn.classList.add('is-unavailable'); btn.setAttribute('aria-label', value + ' (esgotado)'); }
        btn.addEventListener('click', function () { self.pick(optIndex, value); });
        list.appendChild(btn);
      });
      var group = el('div', { class: 'fl-opt' + (isSize ? ' fl-opt--size' : '') + (isColor ? ' fl-opt--color' : '') }, [head, list]);
      self.optionsWrap.appendChild(group);
    });
  };

  /* ---------- Assinatura (selling plans) ---------- */
  FlProduct.prototype.plans = function () {
    var product = this.product();
    var groups = product.selling_plan_groups || [];
    var want = this.subWrap ? norm(this.subWrap.dataset.group) : '';
    if (want) {
      var filtered = groups.filter(function (g) { return norm(g.name) === want; });
      if (filtered.length) groups = filtered;
    }
    var allocs = (this.variant && this.variant.selling_plan_allocations) || [];
    var out = [];
    groups.forEach(function (g) {
      g.selling_plans.forEach(function (sp) {
        var a = allocs.find(function (x) { return x.selling_plan_id === sp.id; });
        if (a) out.push({ id: sp.id, name: sp.name, price: a.price, compare: a.compare_at_price });
      });
    });
    return out;
  };

  FlProduct.prototype.renderSub = function () {
    if (!this.subWrap) return;
    var self = this, fmt = this.data.moneyFormat;
    var plans = this.plans();
    var list = this.subWrap.querySelector('[data-fl-sub-options]');
    var perks = this.subWrap.querySelector('[data-fl-sub-perks]');
    if (!plans.length || !list) {
      this.subWrap.hidden = true; this.planId = null; this.syncPlanInput(); return;
    }
    this.subWrap.hidden = false;
    if (this.planId && !plans.some(function (p) { return p.id === self.planId; })) this.planId = null;
    list.innerHTML = '';
    var v = this.variant;
    function option(id, title, sub, price, compare, badge) {
      var on = (id === null && self.planId === null) || (id !== null && id === self.planId);
      var lab = el('button', { type: 'button', class: 'fl-offer fl-sub__opt' + (on ? ' is-selected' : ''), 'aria-pressed': String(on) }, [
        el('span', { class: 'fl-offer__radio' }),
        el('span', { class: 'fl-offer__text' }, [
          el('span', { class: 'fl-offer__label', text: title }),
          sub ? el('span', { class: 'fl-offer__sub', text: sub }) : null
        ]),
        el('span', { class: 'fl-offer__price' }, [
          el('span', { class: 'fl-offer__now', text: formatMoney(price, fmt) + (id !== null ? '/mês' : '') }),
          compare && compare > price ? el('s', { class: 'fl-offer__was', text: formatMoney(compare, fmt) }) : null
        ]),
        badge ? el('span', { class: 'fl-offer__badge fl-badge', text: badge }) : null
      ]);
      lab.style.gridTemplateColumns = 'auto 1fr auto';
      lab.addEventListener('click', function () { self.planId = id; self.renderSub(); self.renderPrice(); });
      list.appendChild(lab);
    }
    option(null, this.subWrap.dataset.once || 'Compra única', '', v.price, v.compare_at_price, '');
    var base = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price;
    plans.forEach(function (p) {
      var off = base > p.price ? Math.round((base - p.price) * 100 / base) : 0;
      var extra = v.price > p.price ? 'Economize ' + formatMoney(v.price - p.price, fmt) + ' por mês' : String(p.name || '').trim();
      option(p.id, self.subWrap.dataset.title || 'Assinatura', extra, p.price, base, off ? off + '% OFF' : '');
    });
    if (perks) perks.hidden = this.planId === null;
    this.syncPlanInput();
  };

  FlProduct.prototype.syncPlanInput = function () {
    if (!this.planInput) return;
    this.planInput.disabled = !this.planId;
    this.planInput.value = this.planId || '';
  };

  FlProduct.prototype.renderPrice = function () {
    var v = Object.assign({}, this.variant), fmt = this.data.moneyFormat, root = this.root;
    if (this.planId) {
      var pid = this.planId;
      var pl = this.plans().filter(function (p) { return p.id === pid; })[0];
      if (pl) { v.compare_at_price = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price; v.price = pl.price; }
    }
    var now = root.querySelector('[data-fl-now]');
    var was = root.querySelector('[data-fl-was]');
    var badge = root.querySelector('[data-fl-save-badge]');
    var inst = root.querySelector('[data-fl-inst]');
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (now) now.textContent = formatMoney(v.price, fmt);
    if (was) { was.hidden = !onSale; if (onSale) was.textContent = formatMoney(v.compare_at_price, fmt); }
    if (badge) {
      badge.hidden = !onSale;
      if (onSale) badge.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF';
    }
    var n = Number(this.data.installments) || 1;
    if (inst && n > 1) inst.textContent = 'ou ' + n + 'x de ' + formatMoney(Math.round(v.price / n), fmt) + ' sem juros';

    // preço de cada oferta acompanha a variante escolhida quando possível
    var self = this;
    this.offerEls.forEach(function (label) {
      var o = self.data.offers[Number(label.dataset.flOffer)];
      if (!o) return;
      var match = self.matchVariantIn(o.product) || o.product.variants[0];
      var nowEl = label.querySelector('[data-fl-offer-now]');
      if (nowEl && match) nowEl.textContent = formatMoney(match.price, fmt);
    });

    var sp = root.querySelector('[data-fl-sticky-price]');
    var sw = root.querySelector('[data-fl-sticky-was]');
    var st = root.querySelector('[data-fl-sticky-title]');
    if (sp) sp.textContent = formatMoney(v.price, fmt);
    if (sw) { sw.hidden = !onSale; if (onSale) sw.textContent = formatMoney(v.compare_at_price, fmt); }
    if (st) st.textContent = this.data.offers[this.offerIndex].label || this.product().title;
  };

  FlProduct.prototype.matchVariantIn = function (product) {
    var cur = this.product();
    var wanted = {};
    var sel = this.selected;
    cur.options.forEach(function (name, i) { wanted[norm(name)] = sel[i]; });
    return product.variants.find(function (v) {
      return product.options.every(function (name, i) {
        var w = wanted[norm(name)];
        if (!w) return true;
        return SIZE_WORDS.test(name) ? sizeKey(v.options[i]) === sizeKey(w) : norm(v.options[i]) === norm(w);
      });
    });
  };

  FlProduct.prototype.renderButton = function () {
    if (!this.submit) return;
    var ok = this.variant && this.variant.available;
    this.submit.disabled = !ok;
    if (this.submitText) this.submitText.textContent = ok ? this.buttonLabel : 'Esgotado';
    var sb = this.root.querySelector('[data-fl-sticky-btn]');
    if (sb) sb.disabled = !ok;
  };

  /* ---------- Carrinho ---------- */
  FlProduct.prototype.initForm = function () {
    if (!this.form) return;
    var self = this;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.addToCart();
    });
  };

  FlProduct.prototype.addToCart = function () {
    var self = this;
    if (!this.variant || !this.variant.available || this.busy) return;
    this.busy = true;
    this.submit.classList.add('is-loading');
    if (this.error) this.error.hidden = true;

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [Object.assign({ id: this.variant.id, quantity: 1 }, this.planId ? { selling_plan: this.planId } : {})] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) {
          throw new Error(res.body.description || res.body.message || 'Não foi possível adicionar ao carrinho.');
        }
        document.dispatchEvent(new CustomEvent('fl:cart:added', { detail: res.body }));
        return self.openCart();
      })
      .catch(function (err) {
        if (self.error) { self.error.textContent = err.message; self.error.hidden = false; }
      })
      .finally(function () {
        self.busy = false;
        self.submit.classList.remove('is-loading');
      });
  };

  FlProduct.prototype.openCart = function () {
    // 1) UpCart (app de carrinho lateral usado na loja)
    if (typeof window.upcartRefreshCart === 'function' || typeof window.upcartOpenCart === 'function') {
      try {
        var p = typeof window.upcartRefreshCart === 'function' ? window.upcartRefreshCart() : null;
        Promise.resolve(p).then(function () { if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart(); });
      } catch (e) { console.warn(e); }
      return;
    }
    // 2) carrinho lateral do tema
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function') {
      var ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
      return fetch(window.location.pathname + '?sections=' + ids.join(','))
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ sections: sections });
        })
        .catch(function () { window.location.href = '/cart'; });
    }
    // 3) página do carrinho
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  };

  /* ---------- Barra fixa ---------- */
  FlProduct.prototype.initSticky = function () {
    var bar = this.root.querySelector('[data-fl-sticky]');
    if (!bar || !this.submit) return;
    var self = this;
    var btn = bar.querySelector('[data-fl-sticky-btn]');
    var shown = false, ticking = false;
    function update() {
      ticking = false;
      var r = self.submit.getBoundingClientRect();
      var sectionEnd = self.root.getBoundingClientRect().bottom;
      // aparece depois que o botão principal saiu da tela por cima; some no fim da página
      var want = r.bottom < 0 && sectionEnd > -99999;
      if (want === shown) return;
      shown = want;
      bar.classList.toggle('is-visible', want);
      bar.setAttribute('aria-hidden', String(!want));
      if (btn) btn.tabIndex = want ? 0 : -1;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
    if (btn) btn.addEventListener('click', function () { self.addToCart(); });
  };

  function boot() {
    document.querySelectorAll('[data-fl-product]').forEach(function (root) {
      if (root.__fl) return;
      root.__fl = new FlProduct(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
